import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Button from '../../Button/index.esm.js';

var CodeCopyButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var theme = props.theme,
      rest = _objectWithoutPropertiesLoose(props, ["theme"]);

  return React__default.createElement(Button, _extends({
    ref: ref,
    size: "xs",
    appearance: theme === 'dark' ? 'secondary' : undefined,
    iconBefore: "small-copy",
    spacing: "compact",
    position: "absolute",
    zIndex: "z-10",
    inset: ['top-0', 'right-0'],
    margin: ['mt-3', 'mr-3'],
    backgroundOpacity: [theme === 'dark' ? 'bg-opacity-25' : 'bg-opacity-75', 'hover:bg-opacity-100', 'focus:bg-opacity-100']
  }, rest));
});

if (__DEV__) {
  CodeCopyButton.displayName = 'CodeCopyButton';
}

export default CodeCopyButton;
//# sourceMappingURL=index.esm.js.map
